
export type SupportedThemes = "dark" | "light"
export type ColorTheme = {
  primaryBackgroundColor: string,
  secondaryBackgroundColor: string,
  primaryTextColor: string,
  shadowColor: string,
  hoverColor: string,
  themeOverrideColor?: string
}

export class Themes {

  static light: ColorTheme = {
    primaryBackgroundColor: "#f4f7fc",
    secondaryBackgroundColor: "#fff",
    primaryTextColor: "#1a1a1a",
    shadowColor: "#e5e9f2",
    hoverColor: "#00005511",
  }
  static dark: ColorTheme = {
    primaryBackgroundColor: "#1e1f21",
    secondaryBackgroundColor: "#2a2b2d",
    primaryTextColor: "#fff",
    shadowColor: "#111",
    hoverColor: "#ffffff22",
    themeOverrideColor: "#343538",
  }

  static currentTheme = Themes.light
  static updateTheme() {
    document.documentElement.style.setProperty("--bg-color", this.currentTheme.primaryBackgroundColor);
    document.documentElement.style.setProperty("--bg-2-color", this.currentTheme.secondaryBackgroundColor);
    document.documentElement.style.setProperty("--text-color", this.currentTheme.primaryTextColor);
    document.documentElement.style.setProperty("--primary-text-color", this.currentTheme.primaryTextColor);
    document.documentElement.style.setProperty("--shadow-color", this.currentTheme.shadowColor);
    document.documentElement.style.setProperty("--hover-color", this.currentTheme.hoverColor);
    document.documentElement.style.setProperty("--theme-override-color", this.currentTheme.themeOverrideColor ?? "var(--primary-color)");
  }
}
